/* global cdata, contentData, analytics, MR */

// polyfill stable 'core-js' features - ES and web standards:`
// https://github.com/zloirock/core-js
import 'core-js/stable';

// external dependencies
import Vue from 'vue';
import AsyncComputed from 'vue-async-computed';
import VueAxios from 'vue-axios';
import axios from 'axios';
import VueCookies from 'vue-cookies';
import Vuelidate from 'vuelidate';
import VueRouter from 'vue-router';
import FocusLock from 'vue-focus-lock';
import MaskedInput from 'vue-masked-input';
import slick from 'vue-slick';
import Tooltip from 'vue-directive-tooltip';
import 'string-includes-polyfill';
import 'polyfill-array-includes';
import * as Sentry from '@sentry/browser';

// jquery
window.$ = window.jQuery = require('jquery');
require('jquery.cookie');

$.fn.customDropdown = function() {
  var realDropdown = this;
  var dropdownTyping = {
    search: '',
    timeout: null
  };
  var data = [];
  var selected;
  var customId;

  if (!realDropdown.is('select')) {
    return;
  }

  realDropdown.children('option').each(function() {
    var self = $(this);
    var classAttr = self.attr('class');
    var item = {
      val: self.val(),
      text: self.text(),
      selected: false,
      classes: classAttr ? classAttr : null
    };

    if (!selected) {
      selected = item;
    }

    if (self.is(':selected')) {
      selected = item;
      item.selected = true;
    }
    if (item.val != "?") {
      data.push(item);
    }
  });

  customId = realDropdown.data('custom-id');
  if (customId) {
    $('[data-custom-rel="' + customId + '"]').remove();
    realDropdown.removeClass('hiddenButPresent');
  }

  var cssProps = [
    'vertical-align',
    'float',
    'display'
  ];

  var cont = $('<div/>')
    .addClass('customDropdown')
    .css(realDropdown.css(cssProps))
    .addClass(realDropdown.attr('class'));

  if (realDropdown.attr("data-mr-ass")) {
    cont.attr("data-mr-ass", realDropdown.attr("data-mr-ass"));
  }

  if (cont.css('min-width') === '0px') {
    cont.css('min-width', realDropdown.outerWidth());
  }

  if (realDropdown.is(':disabled')) {
    cont.addClass('disabled');
  }

  realDropdown.addClass('hiddenButPresent');

  customId = new Date().getTime().toString(36);
  realDropdown.data('custom-id', customId);
  // Since this isn't real we have to set it as an attribute and not use data... for reasons?
  cont.attr('data-custom-rel', customId);
  if (!selected) {
    selected = {};
  }
  var select = $('<div/>')
    .addClass('select')
    .append(
      $('<div/>').html(selected.text).addClass(selected.classes),
      $('<div/>').addClass('arrow down')
    );
  var options = $('<ul/>').addClass('option');
  options.attr('body-scroll-lock-ignore', '');

  if (realDropdown.attr)

    $.each(data, function() {
      var opt = $('<li/>')
        .data('val', this.val)
        .html(this.text);

      if (this.selected) {
        opt.addClass('selected');
      }

      if (this.classes) {
        opt.addClass(this.classes);
      }

      options.append(opt);
    });

  select.mousedown(function() {
    select.data("mousedown", true);
  });

  select.mouseup(function() {
    select.data("mousedown", false);
  });

  select.focus(function() {
    if (!select.data("mousedown")) {
      select.click();
    }
  });

  select.on('click', function(e) {
    e.stopPropagation();

    if (realDropdown.is(':disabled')) {
      return;
    }

    if (options.is('.expanded')) {
      contractOptions();
    } else {
      expandOptions();
    }
  });

  realDropdown.change(function() {
    var sel = $(this).children(':selected');

    select
      .children('div:first')
      .html(sel.text());

    options
      .children('li')
      .removeClass('selected');

    options
      .children('li')
      .each(function() {
        var li = $(this);

        if (li.data('val') == sel.val()) {
          li.addClass('selected');
          return false;
        }
      });
    contractOptions();
  });

  cont
    .append(select)
    .append(options);

  realDropdown.after(cont);

  $("#container :input, #container .customDropdown > .select").not('.hide').each(function(i) {
    $(this).attr('tabindex', i + 1);
    if ($(this).is('.select')) {
      $(':input[tabindex="' + (i + 1) + '"]').removeAttr('tabindex');
    }
  });

  function keyPress(e) {
    var current = options.children('li.selected');
    var selected;

    // Special control keys
    switch (e.which) {
      case 27: // Escape
        contractOptions();
        break;

      case 9: // Tab
      case 13: // Return
        triggerOptionSelect();
        contractOptions();
        break;

      case 38: // Up
        selected = current.prev();
        if (selected.length === 0) {
          selected = options.children('li').last();
        }
        break;

      case 40: // Down
        selected = current.next();
        if (selected.length === 0) {
          selected = options.children('li').first();
        }
        break;
    }


    // Detect typing
    if (!selected && e.which >= 48 && e.which <= 90) {
      clearTimeout(dropdownTyping.timeout);
      dropdownTyping.search += String.fromCharCode(e.which);
      dropdownTyping.timeout = setTimeout(clearTextSearch, 600);
      selected = searchOptions();
    }

    if (selected) {
      selectOption(selected);
    }
  }

  function selectOption(elem) {
    elem
      .addClass('selected')
      .siblings()
      .removeClass('selected');

    options.scrollTop(0).scrollTop(elem.position().top);
  }

  function clearTextSearch() {
    clearTimeout(dropdownTyping.timeout);
    dropdownTyping.search = '';
  }

  function searchOptions() {
    var search = new RegExp('^' + dropdownTyping.search, 'i');

    // We'd use filter here if it was supported in more browsers.
    var selected;
    options.children('li').each(function() {
      if (search.test($(this).text())) {
        selected = $(this);
        return false;
      }
    });
    return selected;
  }

  function stopScroll(e) {
    if (e.which == 40 || e.which == 38) {
      e.preventDefault();
      return false;
    }
  }

  function triggerOptionSelect() {
    var selected = options.children('li.selected');
    realDropdown
      .val(selected.data('val'))
      .change();
  }

  function contractOptions() {
    if (realDropdown.is(':disabled')) {
      return;
    }

    select.off('keydown', keyPress);
    $(window).off('keydown', stopScroll);

    var arrow = options.parents('.customDropdown').find('.arrow');
    $('body').off('click');

    arrow
      .removeClass('up')
      .addClass('down');

    select.removeClass('expanded');
    options.removeClass('expanded');
  }

  function expandOptions() {
    if (realDropdown.is(':disabled')) {
      return;
    }

    select.on('keydown', keyPress);
    $(window).on('keydown', stopScroll);

    var arrow = options.parents('.customDropdown').find('.arrow');
    arrow.addClass('up').removeClass('down');

    select.addClass('expanded');
    options.addClass('expanded');
    $('body').off('click').on('click', function() {
      contractOptions();
    });
    options.children().off('mousedown').on('mousedown', function(e) {
      e.stopPropagation();
      selectOption($(this));
      triggerOptionSelect();
    });
  }

  return cont;
};

// internal dependencies
import store from './store';
import { mapState, mapActions, mapMutations } from "vuex";

import { getObjProperty } from "./utilities/mrVueUtils";

import globalMixins from './mixins/globalMixins.js';
import cartMixin from './mixins/cartMixin.js';
import customerMixin from './mixins/customerMixin.js';
import advisorMixin from './mixins/advisorMixin.js';
import xsellMixin from './mixins/xsellMixin.js';

import filters from './filters.js';

import applyPromo from './components/applyPromo';
import calendar from './components/calendar';
import captcha from './components/captcha';
import CenterSelectedNav from './components/CenterSelectedNav';
import dropdown from './components/dropdown';
import goToPath from './components/goToPath';
import horizontalSelector from './components/horizontalSelector';
import imgBox from './components/imgBox';
import interval from './components/interval';
import modal from './components/modal';
import AppModal from './components/AppModal';
import Notifications from './components/Notifications';
import mrNewsletterSubscription from './components/mrNewsletterSubscription';
import mrSignIn from './components/mrSignIn';
import mrSiteSearch from './components/mrSiteSearch';
import party from './components/party';
import product from './components/product';
import products from './components/products';
import proxy from './components/proxy';
import siteMessages from './components/siteMessages';
import splitImageCompare from './components/splitImageCompare';
import stars from './components/stars';
import stickyWrap from './components/stickyWrap';
import touch from './components/touch';
import toggle from './components/toggle';
import trackEvent from './components/trackEvent';
import tryItOn from './components/tryItOn';
import visibleTrigger from './components/visibleTrigger';
import ymkWrap from './components/ymkWrap';
import TopMenu from './components/Dashboard/TopMenu';
import youtubePlayer from './components/youtubePlayer';

import Dashboard from './components/Dashboard';
import ColorSolutions from './components/ColorSolutions';

import Recommendations from './components/Recommendations';

import PdpEntry from './components/PDP/PdpEntry';
import ColorKitPdp from './components/PDP/ColorKitPdp';
import Cart from './components/Cart';

//- with VueDevtools 5.0.6 dynamic components error out, to avoid the issue
//- have to import each modal component and register it here
import AddressDeleteHasSubsModal from './components/AddressBook/AddressDeleteHasSubsModal';
import AddressDeleteModal from './components/AddressBook/AddressDeleteModal';
import AddressEditModal from './components/AddressBook/AddressEditModal';
import AddressVerifyModal from './components/AddressBook/AddressVerifyModal';
import AddressUpdateSubsModal from './components/AddressBook/AddressUpdateSubsModal';
import CartSelectPaymentMethodModal from './components/Cart/CartSelectPaymentMethodModal';
import CartRemovePromoModal from './components/Cart/CartTotals/CartRemovePromoModal';
import ColorSolutionsColoristOpinionModal from './components/ColorSolutions/ColorSolutionsColoristOpinionModal';
import ColorSolutionsMoreOptionsModal from './components/ColorSolutions/ColorSolutionsMoreOptionsModal';
import PaymentDeleteHasSubsModal from './components/PaymentProfiles/PaymentDeleteHasSubsModal';
import PaymentDeleteModal from './components/PaymentProfiles/PaymentDeleteModal';
import PaymentEditModal from './components/PaymentProfiles/PaymentEditModal';
import PaymentUpdateSubsModal from './components/PaymentProfiles/PaymentUpdateSubsModal';
import EditAutoDeliveryAddressModal from './components/Dashboard/Purchases/EditAutoDelivery/EditAutoDeliveryAddressModal';
import EditAutoDeliveryCancelModal from './components/Dashboard/Purchases/EditAutoDelivery/EditAutoDeliveryCancelModal';
import EditAutoDeliveryCancelReasonsModal from './components/Dashboard/Purchases/EditAutoDelivery/EditAutoDeliveryCancelReasonsModal';
import EditAutoDeliveryChangeColorModal from './components/Dashboard/Purchases/EditAutoDelivery/EditAutoDeliveryChangeColorModal';
import EditAutoDeliveryFrequencyModal from './components/Dashboard/Purchases/EditAutoDelivery/EditAutoDeliveryFrequencyModal';
import EditAutoDeliveryPaymentModal from './components/Dashboard/Purchases/EditAutoDelivery/EditAutoDeliveryPaymentModal';
import EditAutoDeliveryCancelOfferModal from './components/Dashboard/Purchases/EditAutoDelivery/EditAutoDeliveryCancelOfferModal';
import EditAutoDeliveryCancelFinalModal from './components/Dashboard/Purchases/EditAutoDelivery/EditAutoDeliveryCancelFinalModal';
import EditAutoDeliveryChooseDateModal from './components/Dashboard/Purchases/EditAutoDelivery/EditAutoDeliveryChooseDateModal';
import EditAutoDeliveryPauseModal from './components/Dashboard/Purchases/EditAutoDelivery/EditAutoDeliveryPauseModal';
import PostponeSubscriptionModal from './components/Dashboard/Purchases/PostponeSubscriptionModal';
import ConfirmRefillAddonModal from './components/Dashboard/Welcome/ReturnCustomer/ConfirmRefillAddonModal';
import BoostModal from './components/Dashboard/Welcome/ReturnCustomer/BoostModal';
import WelcomeToRCDModal from './components/Dashboard/WelcomeToRCDModal';
import ConfirmDialogTemplate from './components/ConfirmDialogTemplate';
import PdpPlaygroundModal from './components/PDP/ColorKitPdp/PdpPlaygroundModal';
import PurchasePanel from './components/PDP/PurchasePanel/PurchasePanel';
import PdpXsellModal from './components/PDP/PdpXsellModal';
import ColorSelectPlaygroundModal from './components/Dashboard/Welcome/ReturnVisitor/ColorSelectPlaygroundModal';
import PhotoInstructionsModal from './components/PhotoInstructionsModal';
import CartSubPendingModal from './components/Cart/CartRefillCart/CartSubPendingModal';
import CartEmailCaptureModal from './components/Cart/CartEmailCaptureModal';

//- ROUTES
import dashboardRoutes from './components/Dashboard/routes';
import pdpRoutes from './components/PDP/routes';

Vue.use(AsyncComputed);
Vue.use(VueAxios, axios);
Vue.use(VueCookies);
Vue.use(Vuelidate);
Vue.use(VueRouter);
Vue.use(Tooltip);
Vue.use(require('vue-moment'));

Vue.mixin(globalMixins);

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
// - any global component used in CMS should be registered in kebab case
Vue.component('masked-input', MaskedInput);
Vue.component('slick', slick);
Vue.component('focus-lock', FocusLock);

Vue.component('apply-promo', applyPromo);
Vue.component('calendar', calendar);
Vue.component('captcha', captcha);
Vue.component('CenterSelectedNav', CenterSelectedNav);
Vue.component('dropdown', dropdown);
Vue.component('go-to-path', goToPath);
Vue.component('horizontal-selector', horizontalSelector);
Vue.component('img-box', imgBox);
Vue.component('interval', interval);
Vue.component('modal', modal);
Vue.component('mr-newsletter-subscription', mrNewsletterSubscription);
Vue.component('mr-sign-in', mrSignIn);
Vue.component('mr-site-search', mrSiteSearch);
Vue.component('party', party);
Vue.component('product', product);
Vue.component('products', products);
Vue.component('proxy', proxy);
Vue.component('site-messages', siteMessages);
Vue.component('split-image-compare', splitImageCompare);
Vue.component('stars', stars);
Vue.component('sticky-wrap', stickyWrap);
Vue.component('touch', touch);
Vue.component('toggle', toggle);
Vue.component('track-event', trackEvent);
Vue.component('try-it-on', tryItOn);
Vue.component('visible-trigger', visibleTrigger);
Vue.component('ymk-wrap', ymkWrap);
Vue.component('top-menu', TopMenu);
Vue.component('youtube-player', youtubePlayer);

Vue.component('PdpEntry', PdpEntry);
Vue.component('ColorKitPdp', ColorKitPdp);
Vue.component('Cart', Cart);

Vue.component('dashboard', Dashboard);
Vue.component('color-solutions', ColorSolutions);

Vue.component('recommendations', Recommendations);

//- MODALS (temporary, see comment above near imports
Vue.component('AddressDeleteHasSubsModal', AddressDeleteHasSubsModal);
Vue.component('AddressDeleteModal', AddressDeleteModal);
Vue.component('AddressEditModal', AddressEditModal);
Vue.component('AddressVerifyModal', AddressVerifyModal);
Vue.component('AddressUpdateSubsModal', AddressUpdateSubsModal);
Vue.component('CartSelectPaymentMethodModal', CartSelectPaymentMethodModal);
Vue.component('CartRemovePromoModal', CartRemovePromoModal);
Vue.component('ColorSolutionsColoristOpinionModal', ColorSolutionsColoristOpinionModal);
Vue.component('ColorSolutionsMoreOptionsModal', ColorSolutionsMoreOptionsModal);
Vue.component('PaymentDeleteHasSubsModal', PaymentDeleteHasSubsModal);
Vue.component('PaymentDeleteModal', PaymentDeleteModal);
Vue.component('PaymentEditModal', PaymentEditModal);
Vue.component('PaymentUpdateSubsModal', PaymentUpdateSubsModal);
Vue.component('EditAutoDeliveryAddressModal', EditAutoDeliveryAddressModal);
Vue.component('EditAutoDeliveryCancelModal', EditAutoDeliveryCancelModal);
Vue.component('EditAutoDeliveryCancelReasonsModal', EditAutoDeliveryCancelReasonsModal);
Vue.component('EditAutoDeliveryChangeColorModal', EditAutoDeliveryChangeColorModal);
Vue.component('EditAutoDeliveryFrequencyModal', EditAutoDeliveryFrequencyModal);
Vue.component('EditAutoDeliveryPaymentModal', EditAutoDeliveryPaymentModal);
Vue.component('EditAutoDeliveryCancelOfferModal', EditAutoDeliveryCancelOfferModal);
Vue.component('EditAutoDeliveryCancelFinalModal', EditAutoDeliveryCancelFinalModal);
Vue.component('EditAutoDeliveryChooseDateModal', EditAutoDeliveryChooseDateModal);
Vue.component('EditAutoDeliveryPauseModal', EditAutoDeliveryPauseModal);
Vue.component('PostponeSubscriptionModal', PostponeSubscriptionModal);
Vue.component('ConfirmRefillAddonModal', ConfirmRefillAddonModal);
Vue.component('BoostModal', BoostModal);
Vue.component('WelcomeToRCDModal', WelcomeToRCDModal);
Vue.component('ConfirmDialogTemplate', ConfirmDialogTemplate);
Vue.component('PdpPlaygroundModal', PdpPlaygroundModal);
Vue.component('PurchasePanel', PurchasePanel);
Vue.component('PdpXsellModal', PdpXsellModal);
Vue.component('ColorSelectPlaygroundModal', ColorSelectPlaygroundModal);
Vue.component('PhotoInstructionsModal', PhotoInstructionsModal);
Vue.component('CartSubPendingModal', CartSubPendingModal);
Vue.component('CartEmailCaptureModal', CartEmailCaptureModal);

Vue.config.errorHandler = function(err, vm, info) {
  //- have to manually log the error to console when using errorHandler
  console.error(err);

  //- send the error to Sentry for production monitoring
  if (Sentry) {
    Sentry.captureException(err);
    Sentry.setExtra("info", info);
  }
};

export const router = new VueRouter({
  mode: 'history',
  routes: [...dashboardRoutes, ...pdpRoutes],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 10 }
      };
    } else if (to.meta.noScroll) {
      return false;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) {
    return next();
  }

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
      const tag = document.createElement('meta');

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute('data-vue-router-controlled', '');

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));

  next();
});

window.mrApp = new Vue({
  el: '#mrVueApp',
  store,
  router,
  components: {
    AppModal,
    Notifications
  },

  mixins: [
    cartMixin,
    customerMixin,
    advisorMixin,
    xsellMixin
  ],

  data() {
    return {
      topNav: {
        mobileNavOpen: false,
        selected: ''
      },

      RCDNavItems: [
        { url: '/dashboard/welcome', text: 'Welcome', out: true },
        { url: '/dashboard/purchases', text: 'Purchases', out: true },
        { url: '/dashboard/account', text: 'Account', out: true },
        { url: '/dashboard/shop', text: 'Shop', out: true },
        { url: '/colorbar', text: 'Color Bar', out: true },
        { url: '/dashboard/how-to', text: 'How To', out: true },
        { url: '/blog', text: 'Blog', out: true }
      ],

      searchControl: {
        open: false
      },

      signInControl: {
        open: false
      },

      footerControl: {
        selected: ''
      },

      chatAvailable: false,

      windowData: {
        breakpoint: '',
        width: 0,
        height: 0,
        scrollTop: 0,
        scrollBottom: 0,
        scrollDirection: 0,
        scrollDepth: 0,
        scrolled: false,
        noScroll: false
      },

      accessibilityViewed: 0
    };
  },
  //- Please use this very selectively
  provide: {
    getObjProperty
  },

  created() {
    this.loadCustomer();
    this.setCdata(cdata);
  },

  computed: {
    appModalVisible() {
      return this.$store.state.modal.visible;
    },

    ...mapState('customer', ['cdata']),

    ...mapState('cart', [
      'cart',
      'refillCart',
      'addingProduct',
      'removingProduct'
    ]),

    MRConfig() {
      return MR.config;
    },

    contentData() {
      let data = {};

      if (contentData) {
        data = contentData;
      }

      return data;
    },

    urlParams() {
      var search = window.location.search;
      if (!search) {
        return {};
      }
      var params = {};
      search.replace(/^\?/, '').split('&').forEach(function(paramStr) {
        var part = paramStr.split('=');
        params[part[0]] = part[1];
      });
      return params;
    },

    customerInfo() {
      return this.$store.state.customer.info;
    }
  },

  methods: {
    ...mapActions([
      'notify',
      'removeNotification'
    ]),

    ...mapActions('customer', [
      'loadCustomer',
      'refreshCustomerCdata'
    ]),

    ...mapMutations('customer', [
      'setCdata'
    ]),

    ...mapActions('cart', [
      'addToCart',
      'removeFromCart'
    ]),

    logOut() {
      var self = this;
      self.$cookies.remove('amazon_Login_state_cache');
      self.$cookies.remove('amazon_Login_accessToken');
      self.$cookies.remove('amazon_Address_consentToken');

      localStorage.removeItem('ajs_group_properties');
      localStorage.removeItem('ajs_user_traits');

      this.$http.post('/api/customer/logout').then(() => {
        this.trackEvent('Logged Out');
        analytics.reset();
        window.location = '/';
      });
    },

    //- checks error is user not logged in error, if so will redirect to signin and return true
    checkUserLoginError(errObj) {
      if (!(errObj && errObj.data && errObj.data.message)) {
        return false;
      }
      //If the error message has 'not logged in'
      var isNotLogged = ~errObj.data.message.indexOf('not logged in');
      //Redirect to login page
      var errorDetails = errObj.data.errorDetails || [];
      var doRedirect = errorDetails.some(function(detail) {
        return detail.doRedirect;
      });

      if (doRedirect && isNotLogged) {
        window.location.reload();
        return true;
      }
      return false;
    },

    log(message) {
      console.log(message);
    },

    scrollTo(selector, animateDuration, delay) {
      if (!window.$(selector).length) {
        return;
      }

      var timeoutDelay = delay || 10;
      let elOffsetTop = window.$(selector).offset().top;

      if (window.pageYOffset > elOffsetTop) {
        //- this means we are scrolling up, compensate for the top menu that comes in to the view
        elOffsetTop -= 75;
      }

      setTimeout(function() {
        //Default is to use scroll animation
        if (animateDuration === false) {
          window.$("body, html").scrollTop(elOffsetTop);
        } else {
          // Convert string ms into a number else default to 'slow' animation
          animateDuration = ++animateDuration || 'slow';
          window.$("body, html").animate({ scrollTop: elOffsetTop }, animateDuration);
        }
      }, timeoutDelay);
    },

    openChat() {
      this.$root.trackEvent('CC Chat');
      if (window.zE && typeof window.zE == 'function') {
        window.zE('webWidget', 'open');
      } else {
        window.location.href = "/support";
      }
    },

    setFixedCtaClass(hasFixedCta) {
      if (hasFixedCta) {
        $('body').addClass('has-fixed-cta');
      } else {
        $('body').removeClass('has-fixed-cta');
      }
    }
  },

  mounted() {
    var self = this;

    var trys = 0;
    var chatCheck = setInterval(() => {
      trys += 1;

      if (window.zE && typeof window.zE == 'function') {
        self.chatAvailable = true;
      }

      if (trys >= 10) {
        clearInterval(chatCheck);
      }
    }, 300);

    // set windowData
    self.windowData.width = window.innerWidth;
    self.windowData.height = window.innerHeight;
    self.windowData.scrollTop = window.pageYOffset;
    self.windowData.scrollBottom = window.pageYOffset + window.innerHeight;
    self.windowData.scrollDepth = self.windowData.scrollBottom / self.$el.clientHeight * 100;
    self.windowData.scrolledDepth = 0;
    self.windowData.scrolled = self.windowData.scrolled || self.windowData.scrollTop > 0;

    if (self.windowData.width <= 559) {
      self.windowData.breakpoint = 'mobile';
    } else if (self.windowData.width <= 759) {
      self.windowData.breakpoint = 'tablet';
    } else if (self.windowData.width <= 959) {
      self.windowData.breakpoint = 'desktop-md';
    } else {
      self.windowData.breakpoint = 'desktop';
      self.topNav.mobileNavOpen = false;
    }

    window.addEventListener('resize', function() {
      var previousWidth = self.windowData.width;
      var previousHeight = self.windowData.height;
      var previousBreakpoint = self.windowData.breakpoint;

      self.windowData.width = window.innerWidth;
      self.windowData.height = window.innerHeight;
      self.windowData.scrollBottom = window.pageYOffset + window.innerHeight;

      if (self.windowData.width <= 559) {
        self.windowData.breakpoint = 'mobile';
      } else if (self.windowData.width <= 759) {
        self.windowData.breakpoint = 'tablet';
      } else if (self.windowData.width <= 959) {
        self.windowData.breakpoint = 'desktop-md';
      } else {
        self.windowData.breakpoint = 'desktop';
        self.topNav.mobileNavOpen = false;
      }

      if (previousWidth != self.windowData.width) {
        self.$emit('width-change', self.windowData);
      }
      if (previousHeight != self.windowData.height) {
        self.$emit('height-change', self.windowData);
      }
      if (previousBreakpoint != self.windowData.breakpoint) {
        self.$emit('breakpoint-change', self.windowData);
      }
    });

    window.setInterval(function() {
      if (self.windowData.scrollTop != window.pageYOffset) {
        var oldScrollTop = self.windowData.scrollTop;
        self.windowData.scrollTop = window.pageYOffset;
        self.windowData.scrollBottom = window.pageYOffset + window.innerHeight;
        self.windowData.scrollDirection = oldScrollTop > self.windowData.scrollTop ? -1 : 1;
        self.windowData.scrollDepth = self.windowData.scrollBottom / self.$el.clientHeight * 100;
        self.windowData.scrolled = self.windowData.scrolled || self.windowData.scrollTop > 0;
        self.$emit('scroll-change', self.windowData);

        // scrolled depth tracking
        if (self.contentData.depthTracking) {
          var trackingData = {
            url: window.location.href,
            breakpoint: self.windowData.breakpoint,
            uri: self.contentData.uri,
            variationId: self.contentData.variationId,
            targetPlatform: self.contentData.targetPlatform,
            variationKey: self.contentData.variationKey,
            variationName: self.contentData.variationName,
            experimentId: self.contentData.experimentId,
            experimentName: self.contentData.experimentName
          };

          if (self.windowData.scrollDepth > 25 && self.windowData.scrolledDepth < 25) {
            trackingData.percent = 25;
            self.trackEvent('Scroll Depth', trackingData);
          }
          if (self.windowData.scrollDepth > 50 && self.windowData.scrolledDepth < 50) {
            trackingData.percent = 50;
            self.trackEvent('Scroll Depth', trackingData);
          }
          if (self.windowData.scrollDepth > 75 && self.windowData.scrolledDepth < 75) {
            trackingData.percent = 75;
            self.trackEvent('Scroll Depth', trackingData);
          }
          if (self.windowData.scrollDepth >= 100 && self.windowData.scrolledDepth < 100) {
            trackingData.percent = 100;
            self.trackEvent('Scroll Depth', trackingData);
          }
        }

        // scrolledDepth should updated after depth tracking
        self.windowData.scrolledDepth = self.windowData.scrollDepth > self.windowData.scrolledDepth ? self.windowData.scrollDepth : self.windowData.scrolledDepth;
      }

      if (!self.accessibilityViewed) {
        self.accessibilityViewed = $('#ada_help_container').length;
        if (self.accessibilityViewed) {
          // should only trigger one time when the ada_help_container gets added to the page
          self.trackEvent('Accessiblity Widget Viewed');
        }
      }
    }, 200);

    // eslint-disable-next-line no-undef
    var emailCapture = new EmailCapture(cdata);
    emailCapture.executeEmailCaptureCampaigns();
  }
});